import axios from 'axios'

const state = () => ({
  categories: [],
  filterCategories: [],
  loaded: false
})

const getters = {
}

const mutations = {
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setCategories (state, payload) {
    state.categories = payload
  },
  setFilterCategories (state, payload) {
    state.filterCategories = payload
  },
  addFilterCategory (state, payload) {
    state.filterCategories.push(payload)
  },
  removeFilterCategory (state, payload) {
    state.filterCategories.splice(state.filterCategories.indexOf(payload), 1)
  }
}

const actions = {
  async get ({ commit }) {
    commit('setLoaded', false)
    try {
      const response = await axios.get(window.app.dealersearch_list.api_base + 'dealer-attributes' + '/')
      commit('setCategories', response.data)
      for (const category in state.categories) {
        commit('addFilterCategory', category.uid)
      }
      commit('setLoaded', true)
      return response
    } catch (e) {
      commit('setErrors', e, { root: true })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
